export default __webpack_public_path__ + "static/media/loading.e80fa95c.gif";